import React, { ReactNode } from "react";
import styled from "styled-components";

interface OverlayProp {
  handleClick?: () => void;
  children?: ReactNode;
}

const Overlay = ({ handleClick, children }: OverlayProp) => {
  return (
    <OverlayWrapper className="" onClick={handleClick}>
      {children}
    </OverlayWrapper>
  );
};

export default Overlay;

const OverlayWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100vh;
  width: 100%;
  z-index: 30;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
`;
